import React, { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { setCondicionFiscal, clearCondicionFiscal } from "../actions";
import { makeStyles } from "@mui/styles";
import CondicionFiscalSelector from "~business/condicionFiscalSelector/CondicionFiscalSelector";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";
import { OpcionSeleccionada } from "../types";

const SIN_SELECCION: OpcionSeleccionada = { value: null, label: null };

const useStyles = makeStyles((theme) => ({
  cotizador: {
    flexDirection: "row",
    margin: "auto",
    padding: 20,
    paddingBottom: 100,
    maxWidth: 500,
    width: "100%",
    minHeight: "100vh",
  },
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    condicionFiscalSelected: state.condicionFiscalSelected,
  }));

const CondicionFiscalStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { condicionFiscalSelected } = useReduxSelector();

  useEffect(() => {
    dispatch(clearCondicionFiscal());
  }, [dispatch]);

  const handleChange = (event: {
    target: { value: OpcionSeleccionada | null };
  }) => {
    dispatch(setCondicionFiscal(event.target.value));
  };

  return (
    <>
      <div className={classes.cotizador}>
        <div className={classes.title}>
          <PrimaryTitle
            label="¿Cuál es la condición fiscal del asegurado?"
            marginBottom={32}
          />
        </div>
        <CondicionFiscalSelector
          value={condicionFiscalSelected ?? SIN_SELECCION}
          onChange={handleChange}
        />
      </div>
    </>
  );
});

export default CondicionFiscalStep;
